module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("e2t0P"))).then(() => parcelRequire('1iHdE'));